import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import {Word, Category} from '../../_models';
import {WordService} from '../../_services/word.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-move-word',
  templateUrl: './move-word.component.html',
  styleUrls: ['./move-word.component.scss']
})
export class MoveWordComponent {

  @Output() refreshEvent = new EventEmitter<string>();
  @Input() intercalaireId: string;
  @Input() word: Word;
  @Input() categories: any;

  constructor(private wordService: WordService) { }

  moveTo(categoryId, subCategoryId) {

    let intercalaireId = this.intercalaireId;

    if (categoryId != "" || subCategoryId != "") {
      intercalaireId = "";
    }

    this.wordService.move(this.word.id, intercalaireId, categoryId, subCategoryId).pipe(first()).subscribe(result => {
        this.refreshEvent.emit();
    });
  }

  close() {
    this.refreshEvent.emit();
  }

}
